'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _AdminUIActions = require('conversations-core/actions/AdminUIActions');

var _PubNubPresenceEventTypes = require('conversations-core/constants/PubNubPresenceEventTypes');

var _PubNubClient = require('conversations-core/data/PubNubClient');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (isAdmin) {
  return function (store) {
    return function (next) {
      return function (action) {
        var dispatch = store.dispatch;

        if (action.type === _ActionTypes2.default.RECEIVED_INCOMING_MESSAGE) {
          var message = (0, _getIn2.default)(['payload', 'message'], action);
          var fromVisitor = (0, _ConversationalMessageModel.getFrom)(message) === _RoleTypes2.default.VISITOR;
          if (fromVisitor) {
            dispatch((0, _AdminUIActions.clearRecipientTimeout)(action.payload.channel));
          }
        }

        if (action.type === _ActionTypes2.default.RECEIVED_PUBNUB_PRESENCE) {
          var presenceEvent = action.payload;

          if (presenceEvent.action === _PubNubPresenceEventTypes.LEAVE_EVENT || presenceEvent.action === _PubNubPresenceEventTypes.TIMEOUT_EVENT) {
            dispatch((0, _AdminUIActions.setRecipientTimeout)(presenceEvent.channel));
          }

          if (presenceEvent.action === _PubNubPresenceEventTypes.JOIN_EVENT && presenceEvent.occupancy > 1) {
            dispatch((0, _AdminUIActions.clearRecipientTimeout)(presenceEvent.channel));
          }
        }

        if (action.type === _ActionTypes2.default.LEAVE_CHANNELS) {
          var state = store.getState();
          var pubNubConnected = (0, _clientSelectors.isPubNubConnected)(state);
          if (!pubNubConnected) {
            return next(action);
          }

          var chatConfig = (0, _clientSelectors.getChatConfig)(state);
          if (!chatConfig) {
            window.Raven.captureMessage('NO_CHAT_CONFIG_ON_LEAVE_CHANNEL', {
              extra: {
                clientData: state.clientData.toJS()
              }
            });
            return next(action);
          }

          var subscribeKey = chatConfig.subscribeKey;

          var uuid = (0, _clientSelectors.getUuid)(state);
          var channel = store.getState().currentChannel;

          if (isAdmin) {
            var openConversations = (0, _conversationSelectors.getAllStartedConversations)(state).keySeq().toList();
            var lobbyChannel = (0, _pubNubHelpers.getLobbyChannel)();
            channel = openConversations.concat(lobbyChannel).join(',');
          }
          (0, _PubNubClient.pubnubForcedLeave)(subscribeKey, channel, uuid);
        }

        return next(action);
      };
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/TimeoutMiddleware.js
// module id = 488
// module chunks = 0